import Statistic from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default Statistic;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/statistic/index.js
// module id = 794
// module chunks = 0